var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXpa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#4FA784"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.386 7.22596L9.82408 5.91871L8.26371 8.57653L6.45133 6.47446L7.27258 6.36871L8.11915 7.36321L9.05852 5.69878L4.92415 4.51359C4.8686 4.49713 4.8097 4.49559 4.75338 4.50914C4.69705 4.5227 4.64529 4.55085 4.60331 4.59078C4.56134 4.6307 4.53062 4.68098 4.51427 4.73656C4.49791 4.79213 4.49649 4.85104 4.51015 4.90734L6.34165 12.2626L8.30871 8.95059L10.1211 11.0527L9.29983 11.1584L8.45383 10.1639L6.59196 13.2672L6.86758 14.3753C6.88192 14.4315 6.91074 14.483 6.95117 14.5246C6.99159 14.5662 7.04221 14.5965 7.09798 14.6124C7.15375 14.6283 7.21272 14.6294 7.26902 14.6154C7.32531 14.6014 7.37697 14.573 7.41883 14.5328L14.5232 7.77721C14.5652 7.73748 14.5958 7.68731 14.612 7.63185C14.6282 7.57638 14.6294 7.51761 14.6154 7.46154C14.6015 7.40547 14.5729 7.35412 14.5325 7.31273C14.4922 7.27133 14.4416 7.24139 14.386 7.22596Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXpa);
export default __webpack_public_path__ + "static/media/xpa.9ce564c026043e5b3869aca4b9615a05.svg";
export { ForwardRef as ReactComponent };